import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonLoading,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar
} from '@ionic/react'
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import { State } from '../../store'
import { login, loginType } from '../../store/auth'
import { addNotification, addNotificationType } from '../../store/notification'

interface StateProps {
  authenticated?: boolean
}

interface DispatchProps {
  login: loginType
  addNotification: addNotificationType
}

type Props = RouteComponentProps & StateProps & DispatchProps

const Login: React.FC<Props> = props => {
  const [showLoading, setShowLoading] = useState(false);
  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');

  React.useEffect(() => {
    if (props.authenticated) {
      props.history.push({ pathname: '/online-ordner/profile' })
    }
  }, [props.authenticated])

  const login = async () => {
    setShowLoading(true);
    const success = await props.login(
      username,
      password,
    )

    if (success) {
      await props.addNotification({
        message: 'Willkommen zurück!'
      })
    } else {
      await props.addNotification({
        message: 'Fehler bei der Anmeldung!',
        color: 'danger'
      })
    }

    setShowLoading(false);
  }

  return (
    <IonPage color={'primary'}>
      <IonHeader>
        <IonToolbar color={'primary'}>
          <IonButtons slot="start">
            <IonMenuButton autoHide={false} />
          </IonButtons>
          <IonTitle>Jetzt Anmelden</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent
        className="ion-padding"
        color={'background'}
      >
        <IonLoading
          isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          message={'Anmeldung läuft...'}
        />
        <IonList>
          <IonItem>
            <IonLabel position={'floating'}>Benutzername</IonLabel>
            <IonInput value={username} onIonChange={e => setUsername(e.detail.value!)} />
          </IonItem>

          <IonItem>
            <IonLabel position={'floating'}>Passwort</IonLabel>
            <IonInput type={'password'} value={password} onIonChange={e => setPassword(e.detail.value!)} />
          </IonItem>
        </IonList>

        <IonButton
          onClick={() => login()}
          expand={'block'}
        >
          Jetzt anmelden
        </IonButton>
      </IonContent>
    </IonPage>
  )
}

export default connect<{}, DispatchProps, StateProps, State>(
  ({auth}) => ({
    authenticated: auth.authenticated,
  }),
  {
    login,
    addNotification,
  },
)(Login)
